import { Text, View, StyleSheet } from "@react-pdf/renderer";
import { getFullName } from "@/utils";

const RelatedEmployeeTable = ({ employee }) => {
  const styles = StyleSheet.create({
    table: {
      display: "table",
      width: "auto",
      borderWidth: 1,
      borderColor: "#E9E9E9",
      borderStyle: "solid",
      borderRadius: 6,
    },
    tableRow: {
      flexDirection: "row",
      borderBottomWidth: 1,
      borderColor: "#E9E9E9",
      // minHeight: 22,
    },
    tableRowFirst: {
      borderTopLeftRadius: 6,
      borderTopRightRadius: 6,
    },

    tableRowLast: {
      borderBottomWidth: 0,
      borderBottomLeftRadius: 6,
      borderBottomRightRadius: 6,
    },

    tableRowGray: {
      backgroundColor: "#FCFCFC",
    },

    tableCol: {
      width: "50%",
      padding: "5px 10px",
      borderRightWidth: 1,
      borderColor: "#E9E9E9",
      overflow: "hidden",
      // minHeight: 21,
    },
    tableColLast: {
      borderRightWidth: 0,
    },
  });

  const fields = [
    {
      key: "fullName",
      title: "Сотрудник",
      text: getFullName(
        employee.lastname,
        employee.firstname,
        employee.patronymic,
      ),
    },
    {
      key: "position",
      title: "Должность",
      text: employee.position_name || "-",
    },
    {
      key: "email",
      title: "Email",
      text: employee.secondary_email || "-",
    },
    {
      key: "phone",
      title: "Телефон",
      text: employee.phone || "-",
    },
  ];

  return (
    <View style={styles.table}>
      {/* Table rows */}
      {fields.map((field, index) => (
        <View
          key={index}
          wrap={false}
          style={[
            styles.tableRow,
            index === 0 && styles.tableRowFirst,
            index === fields.length - 1 && styles.tableRowLast,
            index % 2 === 0 && styles.tableRowGray,
          ]}
        >
          <View style={styles.tableCol} wrap={false}>
            <Text>{field.title}</Text>
          </View>
          <View style={[styles.tableCol, styles.tableColLast]} wrap={false}>
            <Text>{field.text}</Text>
          </View>
        </View>
      ))}
    </View>
  );
};

export default RelatedEmployeeTable;
